module.exports = __webpack_public_path__ + "assets/media/day22.641f247c.mp3";